
export default {
    name: 'ModalBuyerProtection',
}
